module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Marvin Dixon’s debut novel, "), _c('em', [_vm._v("Settlement")]), _vm._v(", was published in 2019 inspired by his experiences in the world of financial services. Thus began the story of Justin Kell a financial journalist and private investigator with a passion for ensuring justice is done. "), _c('em', [_vm._v("Payback")]), _vm._v(" (2021) and "), _c('em', [_vm._v("Redemption")]), _vm._v(" (2022) continued Kell’s story with "), _c('em', [_vm._v("Brotherly Love")]), _vm._v(" being the fourth in the series.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Now retired from financial services and focussing on his writing, Marvin Dixon lives in West Yorkshire.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0